// Copyright © 2019-2026 Focal Systems. All rights reserved.

import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { RequirePermission } from "@/components/shared/require-permission";
import { ProductImagesList } from "@/features/ingress/product-images/product-images-list";
import { PAGE_PERMISSIONS } from "@/lib/auth/page-permissions";

export const Route = createFileRoute("/_authenticated/ingress/product-images/")({
  component: () => (
    <RequirePermission permission={PAGE_PERMISSIONS.ingressProductImages}>
      <ProductImagesList />
    </RequirePermission>
  ),
  validateSearch: z.object({ f: z.string().optional() }),
});
